var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8438 3.75H5.15625C3.69125 3.75 2.5 4.87125 2.5 6.25V23.75C2.5 25.1287 3.69125 26.25 5.15625 26.25H24.8438C26.3088 26.25 27.5 25.1287 27.5 23.75V6.25C27.5 4.87125 26.3088 3.75 24.8438 3.75ZM24.8438 23.75H5.15625C5.085 23.75 5.03625 23.73 5.015 23.73C5.00625 23.73 5.00125 23.7325 5 23.74L4.985 6.3075C4.99375 6.295 5.05 6.25 5.15625 6.25H24.8438C24.9425 6.25125 24.9963 6.285 25 6.26L25.015 23.6925C25.0062 23.705 24.95 23.75 24.8438 23.75Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.75H15V16.25H7.5V8.75ZM16.25 18.75H7.5V21.25H22.5V18.75H17.5H16.25ZM17.5 13.75H22.5V16.25H17.5V13.75ZM17.5 8.75H22.5V11.25H17.5V8.75Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.f25c8a754ea2dc1d38bd6ff8cde32f9e.svg";
export { ForwardRef as ReactComponent };